const feedbackText = document.getElementById('feedback-text');
const charCount = document.getElementById('char-count');
const emailInput = document.getElementById('feedback-email');
emailInput.addEventListener('input', () => {
    validateEmail();
});
feedbackText.addEventListener('input', () => {
    console.log('asdada');
    const currentLength = feedbackText.value.length;
    charCount.textContent = `${currentLength} / 300`;
});



function openPopup(type) {
var thankYouPageClose = document.querySelector('.inner-popup-a .close-btn');
thankYouPageClose.style.display='grid';
var popup = document.getElementById('popup');
popup.classList.add('active');
var popupContent = document.querySelector('.popup-content');
var customSent = document.querySelector('.customer-sentiment');
customSent.innerHTML = type;

if (type === 'Positive' || type === 'Negative') {
popup.style.display = 'flex';
setTimeout(function() {
    popupContent.style.opacity = '1';
    popupContent.style.transform = 'scale(1)';
}, 50);
}

}

function submitFeedback() {
   
    console.log(emailValidate);
    const feedbackText = document.getElementById('feedback-text');
  const feedbackError = document.getElementById('feedback-error');
 // Check if the textarea is empty
 if (feedbackText.value.trim() === '') {

    // Show the error message
    feedbackError.style.display = 'block';
  } else {
    // Hide the error message if the textarea is not empty
    feedbackError.style.display = 'none';
    var emailValidate = validateEmail();
    console.log('emailValidate');
    if (emailValidate != false) {
        
  
 
      console.log('adshasdjadahdaudaudhaudh');
var feedbackInput = document.getElementById('feedback-text').value;
var feedbackName = document.getElementById('feedback-name').value;
var feedbackEmail = document.getElementById('feedback-email').value;
var feedbackNumber = document.getElementById('feedback-number').value;
var customSentInput = document.querySelector('.customer-sentiment');
var customerSent = customSentInput.innerHTML;  // Get the innerHTML instead of value
var submitBtn = document.querySelector('.content-btn');
  var currentPageUrl = window.location.href;
submitBtn.classList.add('loading');
console.log('Customer Sentiment: ' + customerSent);
console.log('Feedback submitted: ' + feedbackInput);

setTimeout(function() {
showThankYouMessage();
}, 1500);
setTimeout(function() {
submitBtn.classList.remove('loading');
closePopup();
}, 3000);
if (feedbackInput) {
const api = `https://cpanel.mensabrands.com/FeedbackData/public/feedbackData`;
fetch(api, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ 
        sentiment: customerSent,
        feedback: feedbackInput,
        customer_name: feedbackName,
        customer_email: feedbackEmail,
        customer_number: feedbackNumber,
        store_name: "TrustBasket",
        url: currentPageUrl
    })
})
.then(response => response.json())
.then(data => {
    console.log('return data' + data );
    submitBtn.classList.remove('loading');  
});
}
}
   
}
}

function validateEmail() {
    console.log('submitclick');
    const emailInput = document.getElementById('feedback-email');
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const errorMessageElement = document.getElementById('ContactForm-email-error-{{ section.id }}');
    if (emailInput.value === '') {
        return true;
      }
    if (!emailPattern.test(emailInput.value)) {
      emailInput.classList.add('invalid');
      if (errorMessageElement) {
        errorMessageElement.textContent = 'Please enter a valid email address.';
      } else {
        const errorElement = document.createElement('small');
        errorElement.id = 'ContactForm-email-error-{{ section.id }}';
        errorElement.classList.add('form__message', 'errors');
        errorElement.innerHTML = 'Please enter a valid email address.';
        emailInput.style.marginBottom = '0';
        errorElement.style.color='red';
        emailInput.insertAdjacentElement('afterend', errorElement);
      }
      return false;
    } else {
      emailInput.classList.remove('invalid');
      emailInput.style.marginBottom = '10px';
      if (errorMessageElement) {
        errorMessageElement.textContent = '';
      }
      return true;
    }
}

function showThankYouMessage() {
var currentPage = document.querySelector('.page.active');
var thankYouPage = document.querySelector('.page-thankyou');
var thankYouPageClose = document.querySelector('.inner-popup-a .close-btn');
thankYouPageClose.style.display='none';
currentPage.style.display = 'none';
thankYouPage.style.display = 'block';
thankYouPage.classList.add('active');
}

function closePopup() {
var popup = document.getElementById('popup');
var popupContent = document.querySelector('.popup-content');
var thankYouPage = document.querySelector('.page-thankyou');
var feedbackPage = document.querySelector('.page-feedback');
popup.classList.remove('active');

popupContent.style.opacity = '0';
popupContent.style.transform = 'scale(0.8)';
setTimeout(function () {
popup.style.display = 'none';
thankYouPage.style.display = 'none';
feedbackPage.style.display = 'block';
feedbackPage.classList.add('active');
thankYouPage.classList.remove('active');
}, 300);
}
